import React from 'react';

import { useGetEvent } from '@vlabs/api/artemy/client';
import type { EventId } from '@vlabs/api/artemy/model/EventId';

import {
  EventFaceDetectionSamplePoint3,
  EventBodyDetectionSamplePoint3,
  EventBodyAttributes,
  EventFaceAttributes,
} from '@vlabs/monokit/entities/event-details';

import st from './EventDetectionAttributes.module.sass';

interface EventDetectionAttributesPoint3Props {
  eventId: EventId;
}

function EventDetectionAttributesPoint3({
  eventId,
}: EventDetectionAttributesPoint3Props): React.JSX.Element {
  const { data: event } = useGetEvent(eventId, { target: ['face_detections', 'body_detections'] });
  const faceSampleId = event?.face_detections?.[0]?.sample_id;
  const bodySampleId = event?.body_detections?.[0]?.sample_id;
  return (
    <div className={st.Root}>
      <div className={st.FaceSection}>
        <EventFaceDetectionSamplePoint3
          className={st.Sample}
          sampleId={faceSampleId ?? ''}
        />
        <EventFaceAttributes
          className={st.Attributes}
          eventId={eventId}
        />
      </div>
      {!!event?.body_detections?.length && (
        <div className={st.BodySection}>
          <EventBodyDetectionSamplePoint3
            className={st.Sample}
            sampleId={bodySampleId ?? ''}
          />
          <EventBodyAttributes eventId={eventId} />
        </div>
      )}
    </div>
  );
}

export { EventDetectionAttributesPoint3 };
